import Convenio from './Convenio';

export default Convenio;